import { BodyCopy } from "~/hec/components/ui/body-copy";
import { Card, CardContent } from "~/hec/components/ui/card";
import { Heading } from "~/hec/components/ui/heading";

/**
 * Port of hec-composable `goal-banner/goalBannerHeader.jsx`. The goal hero card:
 * the goal title (rendered as the page `h1`) + its description, centered in a
 * translucent white card over the goal background image.
 */
const GoalBannerHeader = ({
  title,
  description,
}: {
  title?: string;
  description?: string;
}) => (
  <Card
    className="m-auto grid max-w-screen-lg grid-cols-1 rounded-md bg-white/90 p-8"
    data-testid="goal-banner-header"
  >
    <CardContent className="flex h-full flex-col">
      <div className="px-3 py-4 text-center">
        <Heading
          tag="h1"
          variant="h3"
          className="mb-1"
          data-testid="goal-banner-header-heading"
        >
          {title}
        </Heading>
        {description && (
          <BodyCopy data-testid="goal-banner-header-description">
            {description}
          </BodyCopy>
        )}
      </div>
    </CardContent>
  </Card>
);

export default GoalBannerHeader;
